import { render, staticRenderFns } from "./sharedialog.vue?vue&type=template&id=511e8f9a&"
import script from "./sharedialog.vue?vue&type=script&lang=js&"
export * from "./sharedialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports